<template>
  <section class="copyright">
    <a href="https://github.com/maxSedelnikov" target="_blank">
      <b-icon-emoji-smile-upside-down></b-icon-emoji-smile-upside-down>
      <span>Maxim Sedelnikov</span>
    </a>
  </section>
</template>

<script>
export default {
  name: "Copyright"
};
</script>

<style scoped>
.copyright a {
  color: #fff;
  text-decoration: none;
}
.copyright a span {
  padding-left: 5px;
}
</style>